<template>
	<div>
		<div class="container">
			<div class="handle-box">
				<el-select size="small" v-if="isAdmin" @change="agentChange" v-model="query.agentId" filterable
					clearable placeholder="代理商" class="handle-select mr10" style="width: 260px">
					<el-option v-for="item in agents" :key="item.value" :label="item.label"
						:value="item.value"></el-option>
				</el-select>

				<el-select size="small" v-model="query.cardsId" filterable clearable placeholder="请选择号码品牌"
					class="handle-select mr10" style="width:180px">
					<el-option v-for="item in serverLists" :key="item.cardsId" :label="item.cardType"
						:value="item.cardsId"></el-option>
				</el-select>
				<el-button size="mini" type="primary" :class="[theme]" icon="el-icon-search"
					@click="getsipAccountPriceData()">搜索</el-button>
				<el-button size="mini" type="primary" :class="[theme]" @click="getsetPriceVisible"
					v-if="isAdmin">设置</el-button>
			</div>

			<el-table :data="tableData" border class="table" ref="multipleTable" header-cell-class-name="table-header"
				max-height="600" @selection-change="handleSelectionChange"
				:header-cell-style="{ 'text-align': 'center' }" :row-style="{ height: '20px' }"
				:cell-style="{ padding: '6px' }" stripe v-loading="loading">
				<el-table-column prop="agentName" label="代理" align="center"></el-table-column>
				<el-table-column prop="cardName" label="品牌" align="center"></el-table-column>
				<el-table-column prop="price" label="价格" align="center"></el-table-column>
				<el-table-column label="操作" align="center" width="240" v-if="isAdmin">
					<template #default="scope">
						<el-button size="small" type="primary" :class="[theme]"
							@click="showEdit(scope.row)">编辑</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-dialog title="设置价格" v-model="setPriceVisible" width="450px" @close="closeDialog('setPriceForm')">
				<el-form :model="setPriceForm" ref="setPriceForm" label-width="100px">
					<el-form-item prop="agentId" label="代理商">
						<el-select size="small" v-model="setPriceForm.agentId" filterable clearable placeholder="请选择代理商"
							style="width: 100%;">
							<el-option v-for="item in agents" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item prop="cardsId" label="品牌">
						<el-select size="small" v-model="setPriceForm.cardsId" filterable clearable placeholder="请选择品牌"
							style="width: 100%;">
							<el-option v-for="item in serverLists" :key="item.cardsId" :label="item.cardType"
								:value="item.cardsId"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item prop="accountPrice" label="价格">
						<el-input size="small" v-model="setPriceForm.accountPrice" clearable
							placeholder="请输入价格"></el-input>
					</el-form-item>
					<el-form-item class="dis-end">
						<el-button size="small" @click="setPriceVisible=false">取消</el-button>
						<el-button size="small" type="primary" :class="[theme]"
							@click="getsetSipAccountPrice">确定</el-button>
					</el-form-item>
				</el-form>
			</el-dialog>

			<el-dialog title="设置价格" v-model="editVisible" width="450px" @close="closeEditDialog">
				<el-form :model="editForm" ref="editForm" label-width="100px">
					<el-form-item prop="agentName" label="代理商">
						<el-input size="small" v-model="editForm.agentName" disabled></el-input>
					</el-form-item>
					<el-form-item prop="cardName" label="品牌">
						<el-input size="small" v-model="editForm.cardName" disabled></el-input>
					</el-form-item>
					<el-form-item prop="price" label="价格">
						<el-input size="small" v-model="editForm.price" clearable placeholder="请输入价格"></el-input>
					</el-form-item>
					<el-form-item class="dis-end">
						<el-button size="small" @click="editVisible = false">取消</el-button>
						<el-button size="small" type="primary" :class="[theme]"
							@click="getsipAccountPriceUpdate">确定</el-button>
					</el-form-item>
				</el-form>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	import {
		fetchDepartment
	} from '../api/index.js';
	import {
		fetchAgent
	} from '../api/agentIndex.js';
	import {
		fetchCompanyByAgentId,
		fetchDefaultCompanies
	} from '../api/companyIndex';
	import {
		sipAccountPriceQuery,
		serverList,
		setSipAccountPrice,
		sipAccountPriceUpdate
	} from '../api/setMeal.js';
	export default {
		name: 'sipAccountPrice',
		data() {
			return {
				loading: false,
				theme: localStorage.getItem('theme'),
				theme3: localStorage.getItem('theme3'),
				theme8: localStorage.getItem('theme8'),
				query: {
					agentId: '',
					cardsId: '',
				},
				agents: [],
				serverLists: [], //SIPServer服务器的列表
				tableData: [],
				isAdmin: false,
				isAgent: false,
				isNormal: false,
				pageTotal: 0,
				isUseList: [{
					value: true,
					label: '已开通',
				}, {
					value: false,
					label: '未开通',
				}],
				setPriceVisible: false,
				setPriceForm: {
					agentId: '',
					accountPrice: '',
					cardsId: '',
				},
				editVisible: false,
				editForm: {
					price: '',
					cardName: '',
					agentName: '',
					id: ''
				}
			};
		},
		created() {
			this.role = localStorage.getItem('ms_role');
			this.init();
			this.getServerList();
			if (this.role === 'admin') {
				this.isAdmin = true;
			}
			if (this.role == 'agent') {
				this.isAgent = true;
			}
		},
		methods: {

			init() {
				fetchAgent(localStorage.getItem('user')).then(res => {
					this.agents = res.data;
				});
				this.getsipAccountPriceData();
			},
			//sip服务器列表
			getServerList() {
				let data = {
					pageIndex: 1,
					pageSize: 100
				}
				serverList(data).then(res => {
					if (res?.code === 200) {
						this.serverLists = res.data.list;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			getsipAccountPriceData() {
				let data = {
					userId: localStorage.getItem('user'),
					agentId: this.query.agentId,
					cardsId: this.query.cardsId,
				};
				this.loading = true;
				sipAccountPriceQuery(data).then(res => {
					this.loading = false;
					if (res?.code === 200) {
						this.tableData = res.data;
					} else {
						this.$message.error(res.message);
					}
				});
			},

			closeDialog(formName) {
				this.setPriceVisible = false;
			},
			getsetPriceVisible() {
				this.setPriceForm.cardsId = '';
				this.setPriceForm.accountPrice = '';
				this.setPriceForm.agentId = '';
				this.setPriceVisible = true;
			},
			getsetSipAccountPrice() {
				let data = {
					userId: localStorage.getItem('user'),
					cardsId: this.setPriceForm.cardsId,
					accountPrice: this.setPriceForm.accountPrice,
					agentId: this.setPriceForm.agentId,
				};
				setSipAccountPrice(data).then(res => {
					if (res?.code === 200) {
						this.$message.success(res.message);
						this.setPriceVisible = false;
						this.getsipAccountPriceData()
					} else {
						this.$message.error(res.message);
					}
				});
			},
			showEdit(row) {
				this.editForm = row;
				this.editVisible = true;
			},
			getsipAccountPriceUpdate() {
				let data = {
					userId: localStorage.getItem('user'),
					id: this.editForm.id,
					accountPrice: this.editForm.price,
				};
				sipAccountPriceUpdate(data).then(res => {
					if (res?.code === 200) {
						this.editVisible = false;
						this.getsipAccountPriceData()
					} else {
						this.$message.error(res.message);
					}
				});
			},

			closeEditDialog() {
				this.editVisible = false;
				this.getsipAccountPriceData()
			},

		}
	};
</script>

<style scoped>
	.handle-box {
		margin-bottom: 20px;
	}

	.down {
		border: 1px solid #dcdfe6;
		background: #4f7afd;
		color: #ffffff;
		transition: 0.1s;
		font-weight: 500;
		padding: 8px 16px;
		font-size: 12px;
		border-radius: 4px;
		margin-left: 10px;

		display: inline-block;
	}

	.handle-select {
		width: 120px;
	}

	.handle-input {
		width: 300px;
		display: inline-block;
	}

	.table {
		width: 100%;
		font-size: 12px;
	}

	.red {
		color: #ff0000;
	}

	.mr10 {
		margin-right: 10px;
	}

	.grid-con-icon {
		font-size: 50px;
		width: 100px;
		height: 100px;
		text-align: center;
		line-height: 100px;
		color: #fff;
	}

	.grid-cont-right {
		flex: 1;
		text-align: center;
		font-size: 20px;
		font-weight: bold;
		color: #999;
	}

	.grid-content {
		display: flex;
		align-items: center;
		height: 100px;
	}
</style>
<style>
	.import-visible .el-upload {
		width: 100% !important;
		display: flex !important;
		flex-direction: column !important;
		align-items: center !important;
		justify-content: center !important;
	}
</style>